export default "__VITE_ASSET__omfdWR4P__"